import { Box, Text } from '@chakra-ui/react';
import useCurrencyFormatter from '../hooks/useCurrencyFormatter';
import { date } from '../common/time';

type Props = { paymentDeadlines: { date: string; amount: number }[] };

const TooltipDateElement = ({ paymentDeadlines }: Props): JSX.Element => {
  const formatCurrency = useCurrencyFormatter();

  return (
    <Box minW={'300px'}>
      {paymentDeadlines.map((deadline, index, paymentDeadlines) => {
        const lastDate = paymentDeadlines[index - 1]?.date;
        const startDate = lastDate ? date(lastDate).add(1, 'd').format('DD/MM/YYYY') : undefined;
        const endDate = date(deadline.date).format('DD/MM/YYYY');

        return (
          <Box
            key={index}
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
            borderBottom={index < paymentDeadlines.length - 1 ? '1px solid white' : ''}
            p={1}
          >
            <Text textColor={'white'}>
              <Text as={'span'} textColor={'white'}>
                {!startDate
                  ? `Antes o el ${endDate}`
                  : `Del ${lastDate === deadline.date ? endDate : startDate} al ${endDate}`}
              </Text>
            </Text>
            <Text textColor={'white'}>{formatCurrency(deadline.amount)}</Text>
          </Box>
        );
      })}
    </Box>
  );
};

export default TooltipDateElement;
